import { BaseModel } from './base.model';
import { PaymentMethodVendor } from '../enums/payment-method';

export abstract class PaymentMethod extends BaseModel {
  public id: number;
  public type: number;
  public active: boolean;
  public vendor?: PaymentMethodVendor;

  abstract isCard(): boolean;
  abstract isAccount(): boolean;

  constructor(data) {
    super(data);
    if (!data || (data && !data.active)) {
      this.active = false;
    }
  }
}
